import { useEffect, useState } from 'react';
import {
  fetchAuthenticatedObjectUrl,
  getCachedAuthenticatedObjectUrl,
} from './avatarObjectUrlCache';

/**
 * Load an authenticated API image path as a blob object URL.
 * `apiPath` is relative to `/api` (e.g. `/internal-chat/threads/:id/avatar`).
 */
export function useAuthenticatedObjectUrl(
  apiPath: string | null | undefined
): string | null {
  const [objectUrl, setObjectUrl] = useState<string | null>(() =>
    apiPath ? getCachedAuthenticatedObjectUrl(apiPath) : null
  );

  useEffect(() => {
    if (!apiPath) {
      setObjectUrl(null);
      return;
    }

    if (apiPath.startsWith('blob:') || apiPath.startsWith('data:')) {
      setObjectUrl(apiPath);
      return;
    }

    const cached = getCachedAuthenticatedObjectUrl(apiPath);
    if (cached) {
      setObjectUrl(cached);
      return;
    }

    let cancelled = false;
    void fetchAuthenticatedObjectUrl(apiPath).then((next) => {
      if (!cancelled) setObjectUrl(next);
    });

    return () => {
      cancelled = true;
    };
  }, [apiPath]);

  return objectUrl;
}
